module.exports = __webpack_public_path__ + "static/img/mine4.88caac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine4.jpg
// module id = F7Ua
// module chunks = 1